import { engineApi } from "@/api/engineApi";
import { ENGINE_URL } from "@/config";
import { toDateKey } from "@/lib/utils";
import { CandlestickData, Time } from "lightweight-charts-v5";

export const ichimoku = async (data: any) => {
  /** Chikou Span (Lagging Span)  */
  const laggingSpan: number[] = Object.values(data?.ICS_26);

  /** Kijun-sen (Base Line)  */
  const baseLine: number[] = Object.values(data?.IKS_26);

  /** Senkou Span A (Leading Span A) - High band  */
  const leadingSpanA: number[] = Object.values(data?.ISA_9);

  /** Senkou Span B (Leading Span B) - Low Band */
  const leadingSpanB: number[] = Object.values(data?.ISB_26);

  /** Tenkan-sen (Conversion Line)  */
  const conversionLine: number[] = Object.values(data?.ITS_9);
  return { laggingSpan, baseLine, leadingSpanA, leadingSpanB, conversionLine };
};

export const eri = async (data: any, period: number) => {
  return {
    BEARP: data[`BEARP_${period}`],
    BULLP: data[`BULLP_${period}`],
  };
};

export const rvgi = async (data: any, period: number) => {
  return {
    RVGI: data[`RVGI_${period}_4`],
    RVGIS: data[`RVGIs_${period}_4`],
  };
};

export const getGrideValues = async (
  grid_p: string,
  base_p: string,
  high_low_p: string,
) => {
  let url = new URL("/get_grids", ENGINE_URL);
  url.searchParams.append("grid_percentage", grid_p);
  url.searchParams.append("base_price", base_p);
  url.searchParams.append("high_low_percentage", high_low_p);
  let result: any = null;
  try {
    result = await engineApi.get(url.toString());
  } catch (e) {
    console.warn(e);
  }
  return result?.data;
};

export const earnings = async (
  tickerData: CandlestickData<Time>[],
  earningsData: any,
) => {
  return tickerData.map((candle) => {
    const dateKey = toDateKey(candle.time as number);
    const earnings = earningsData?.[dateKey];

    return {
      time: candle.time,
      high: candle.high,
      low: candle.low,
      isEarningsDay: !!earnings,
      status: earnings?.status ?? null,
      companyName: earnings?.company_name ?? null,
      scaledReturn: earnings?.scaled_return ?? null,
      sigma: earnings?.sigma ?? null,
      earningsCallUrl: earnings?.url ?? null,
      color: "#2252cc",
      date: dateKey,
    };
  });
};
